import React, { useState, useEffect } from "react";
import {
  GeneralContainer,
  TagCard,
  TagContainer,
  SelectStyles,
  ModalContainer,
  ModalHeader,
  ModalContent,
  ModalFooter,
  UpdateButton,
  CancelButton,
} from "./CoachEventThemeUpdate.styled";
import { IconButton } from "@material-ui/core";
import { Close, EditTwoTone } from "@material-ui/icons";
import PortalModal from "../../Portals/PortalModal";
import Select from "react-select";
import { NotificationManager } from "react-notifications";
import { UPDATE_COUNSELLING_THEME } from "../../GraphQL/Mutations";
import { clientWellness } from "../../App";
import { useMutation } from "@apollo/client";

const CoachEventThemeUpdate = ({ event, allThemes }) => {
  const [theme, setTheme] = useState([]);
  const [reset, setReset] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [updateCounsellingTheme] = useMutation(UPDATE_COUNSELLING_THEME, {
    client: clientWellness,
  });

  useEffect(() => {
    if (event?.counsellingThemes) {
      let themes = event.counsellingThemes.map((e) => {
        return {
          value: e?.idCounsellingThemeNavigation.idCounsellingTheme,
          label: e?.idCounsellingThemeNavigation.themeName,
        };
      });
      setTheme(themes);
    }
  }, [reset]);

  const handleChange = (e) => {
    if (e.length > 2) {
      NotificationManager.warning(
        "Only two themes can be assigned to a event."
      );
    } else {
      setTheme(e);
    }
  };

  const closeModal = () => {
    setReset(!reset);
    setShowModal(false);
  };

  const handleUpdate = () => {
    if (theme.length > 0) {
      updateCounsellingTheme({
        variables: {
          eventId: event.idEvent,
          counsellingThemeIds: theme.map((e) => e.value),
        },
      })
        .then((response) => {
          if (response?.data?.updateCoachEventCounsellingTheme) {
            setShowModal(false);
            NotificationManager.success("Theme updated successfully", "", 5000);
          } else {
            NotificationManager.error(
              "Something went wrong in updating theme",
              "",
              5000
            );
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      NotificationManager.warning("Please choose the theme to update");
    }
  };

  return (
    <GeneralContainer>
      <TagContainer>
        {theme.map((e) => {
          return <TagCard>{e.label}</TagCard>;
        })}
      </TagContainer>
      <IconButton
        hidden={event.idCategory !== 1}
        onClick={() => setShowModal(true)}
      >
        <label
          style={{
            textDecoration: "underline",
            fontWeight: "bold",
          }}
        >
          Update Theme
        </label>
        <EditTwoTone />
      </IconButton>
      {showModal && (
        <PortalModal>
          <ModalContainer>
            <ModalHeader>
              <label>Update Theme</label>
              <IconButton onClick={closeModal}>
                <Close />
              </IconButton>
            </ModalHeader>
            <ModalContent>
              <Select
                styles={SelectStyles}
                isMulti={true}
                placeholder="Select an option"
                options={allThemes}
                value={theme}
                onChange={handleChange}
              />
            </ModalContent>
            <ModalFooter>
              <UpdateButton onClick={handleUpdate}>Update</UpdateButton>
              <CancelButton onClick={closeModal}>Cancel</CancelButton>
            </ModalFooter>
          </ModalContainer>
        </PortalModal>
      )}
    </GeneralContainer>
  );
};

export default CoachEventThemeUpdate;
